import type { BalancingOutcome, LineRowOutcome } from '@/types';

export const isBalancingOutcome = (outcome?: LineRowOutcome): outcome is BalancingOutcome => {
  return !!outcome && 'isBalancing' in outcome && outcome.isBalancing;
};
